module.exports = __webpack_public_path__ + "static/media/27-9.f0df71ba.mp3";